import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  registerButton: {
    id: 'react-components.deEeEI',
    defaultMessage: 'Register',
  },
  registerFailed: {
    id: 'react-components.fPVPxV',
    defaultMessage: 'Register failed',
  },
  nameLabel: {
    id: 'react-components.dOQCL8',
    defaultMessage: 'Display name',
  },
  nameHelp: {
    id: 'react-components.avzfbD',
    defaultMessage: 'This is used to personalize communication',
  },
  passwordLabel: {
    id: 'react-components.5sg7KC',
    defaultMessage: 'Password',
  },
  emailLabel: {
    id: 'react-components.sy+pv5',
    defaultMessage: 'Email',
  },
  emailInvalid: {
    id: 'react-components.jv0FOj',
    defaultMessage: 'This must be a valid email address',
  },
  emailRequired: {
    id: 'react-components.KssJcX',
    defaultMessage: 'An email address is required',
  },
  organizationLabel: {
    id: 'react-components.K56Dim',
    defaultMessage: 'Organization',
  },
  optional: {
    id: 'react-components.InWqys',
    defaultMessage: 'Optional',
  },
  emailConflict: {
    id: 'react-components.gR2hpT',
    defaultMessage: 'This email address has already been registered.',
  },
  newsletter: {
    id: 'react-components.It/Dy0',
    defaultMessage: 'Yes, I want to be kept up to date with Appsemble news.',
  },
  phoneNumber: {
    id: 'react-components.jdJhOL',
    defaultMessage: 'Phone number',
  },
});
